import { OutboundLink } from "gatsby-plugin-google-analytics";
import styled from "styled-components";

/*****************************************************************************************************
 *** Note: Both Link and NavLink have been refactored into separate component with their own props ***
 *****************************************************************************************************/

export const OutboundLinkStyles = styled(OutboundLink)`
  color: ${(props) => props.theme.colours.midBlue};
  text-decoration: none;
  transition: all 0.2s ease-in;
  &:active {
    outline: none;
  }
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colours.orange};
  }
  // &:visited {
  //   color: ${(props) => props.theme.colours.darkBlue};
  // }
`;

export const ContactNavLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${(props) => props.theme.colours.foreground};
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
  line-height: 100%;
  margin-right: 1.5rem;
  transition: all 0.2s ease-in;
  &:active {
    outline: none;
  }
  &:active,
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colours.orange};
  }
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    margin: 0 0 10px 1rem;
  }
`;
